function do_login(url) {
  var isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    ) && !window.MSStream;
  var targetURL = new URL(url);
  var welfareCommittee = localStorage.getItem('welfare-committee');
  if(welfareCommittee) {
    targetURL.searchParams.append('welfare_committee', welfareCommittee);
  }

  if (isMobile) {
    window.location=targetURL.toString();
    window.location.href=targetURL.toString();
    location=targetURL.toString();
    location.href=targetURL.toString();
  } else {
    var win = window.open(targetURL.toString(), 'login_force', 'width=800, height=600');
    win.focus();
  }
}

function trackModalRegisterView() {
  window.segmentTracking.accountView('register');
}

window.addEventListener('DOMContentLoaded', () => {
  if (!location.href.includes('/account')) {
    // social login event
    $('.js-login-facebook,.js-login-google,.js-login-line').on(
      'click',
      function (e) {
        e.preventDefault();
        const social = $(this).attr('class').replace('button-group js-login-', '');
        const accountType = $(this).attr('data-account-type');
        window.segmentTracking.accountButtonClicked(social + '_' + accountType);

        if (social === 'facebook') {
          do_login(PY3_API_BASE_URL + '/social/login/facebook/');
        } else if (social === 'google') {
          do_login(PY3_API_BASE_URL + '/social/login/google-plus/');
        } else if (social === 'line') {
          do_login(PY3_API_BASE_URL + '/social/login/line/');
        }
        sessionStorage.setItem('isDirectlyFromSocialLogin', true);
      },
    );

    // toggle modal window
    $('#modal-register-link').on('click', function () {
      $('.modal-account-context').css('height', '552px');
      $('.modal-login-form-v2').toggle();
      $('.modal-register-form').toggle();
      trackModalRegisterView();
    });

    $('#modal-login-link').on('click', function () {
      $('.modal-account-context').css('height', '598px');
      $('.modal-login-form-v2').toggle();
      $('.modal-register-form').toggle();
    });

    $('#modal-login-email').on('click', function () {
      $('.modal-account-context').css('height', '456px');
      $('.modal-login-form-v2').toggle();
      $('.modal-login-email').toggle();
      sessionStorage.setItem('login-step', 'second');
    });

    $('#modal-register-email').on('click', function () {
      $('.modal-account-context').css('height', '710');
      $('.modal-register-form').toggle();
      $('.modal-register-email').toggle();
      sessionStorage.setItem('register-step', 'second');
    });

    $('#modal-login-link-from-email').on('click', function () {
      $('.modal-account-context').css('height', '598px');
      $('.modal-login-form-v2').toggle();
      $('.modal-login-email').toggle();
      sessionStorage.setItem('login-step', 'first');
    });

    $('#modal-register-link-from-email').on('click', function () {
      $('.modal-account-context').css('height', '552px');
      $('.modal-register-form').toggle();
      $('.modal-register-email').toggle();
      sessionStorage.setItem('register-step', 'first');
    });

    // handle password confirm
    $('form#create_customer').on('submit', function (e) {
      const cs_sex = $('#cs_sex').val();
      const cs_birthday = $('#cs_birthday').val()
        ? ',' + $('#cs_birthday').val()
        : '';
      const cs_welfare_committee = localStorage.getItem('welfare-committee')
        ? `,welfare-committee__${localStorage.getItem('welfare-committee')}`
        : '';
      $('#customer__tags').val(cs_sex + cs_birthday + cs_welfare_committee);

      window.segmentTracking.accountButtonClicked('account_註冊');
    });

    $('form#customer_login').submit(function (e) {
      window.segmentTracking.accountButtonClicked('account_登入');
    });

    $(document).on('opening', '.remodal', function (event) {
      const isModalLogIn = $(event.target).hasClass('modal-account');
      if (isModalLogIn) {
        window.segmentTracking.accountView('login');
      }
    });
  }
});

$('#cs_sex').change(function () {
  if ($(this).val() !== '') {
    $(this).css('color', '#4a4a4a');
  }
});

$('.icon-eye-login').click(function () {
  if ('password' == $('#customer__password__login').attr('type')) {
    $('#customer__password__login').prop('type', 'text');
    $('i.icon-eye-login').removeClass('icon-eye-close').addClass('icon-eye');
  } else {
    $('#customer__password__login').prop('type', 'password');
    $('i.icon-eye-login').removeClass('icon-eye').addClass('icon-eye-close');
  }
});

$('.icon-eye-register').click(function () {
  if ('password' == $('#customer__password').attr('type')) {
    $('#customer__password').prop('type', 'text');
    $('i.icon-eye-register').removeClass('icon-eye-close').addClass('icon-eye');
  } else {
    $('#customer__password').prop('type', 'password');
    $('i.icon-eye-register').removeClass('icon-eye').addClass('icon-eye-close');
  }
});

$(function () {
  //populate our years select box
  for (i = new Date().getFullYear(); i > 1900; i--) {
    $('#cs_years').append($('<option />').val(i).html(i));
  }
  //populate our months select box
  for (i = 1; i < 13; i++) {
    $('#cs_months').append($('<option />').val(i).html(i));
  }

  //"listen" for change events
  $('#cs_years, #cs_months, #cs_days').change(function () {
    $(this).css('color', '#4a4a4a');
    if ($(this).attr('id') != 'cs_days') {
      updateNumberOfDays();
    }
    formatBirthday();
  });
});

function formatBirthday() {
  let birthday =
    '__birthday_' +
    $('#cs_years').val() +
    addZero($('#cs_months').val()) +
    addZero($('#cs_days').val()) +
    '__';
  if ($('#cs_years').val() && $('#cs_months').val() && $('#cs_days').val()) {
    $('#cs_birthday').val(birthday);
  }
}

//function to update the days based on the current values of month and year
function updateNumberOfDays() {
  $('#cs_days').html('');
  month = $('#cs_months').val();
  year = $('#cs_years').val();
  days = daysInMonth(month, year);

  $('#cs_days').append($('<option />').val('').html('日'));
  for (i = 1; i < days + 1; i++) {
    $('#cs_days').append($('<option />').val(i).html(i));
  }
}

//helper function
function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}

function addZero(s) {
  return s < 10 ? '0' + s : s;
}
